import PNotify from 'pnotify/dist/es/PNotify'
import 'pnotify/dist/es/PNotifyButtons'
import 'pnotify/dist/es/PNotifyDesktop'
import 'pnotify/dist/PNotifyBrightTheme.css'
import 'pnotify/dist/es/PNotifyStyleMaterial'

PNotify.defaults.styling = 'material'
PNotify.defaults.icons = 'material'
PNotify.defaults.modules = {
  Desktop: {
    desktop: true,
    title: 'Tekniktavlan'
  }
}

export default {

}



// WEBPACK FOOTER //
// ./src/PNotify.js